import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class OpenChatService {
  baseUrl: string = Constants.LLM_REQUEST_URL;
  constructor(private http: HttpClient) {}

  askFromModel(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl, data);
  }
}
